module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwAgMAAAAqbBEUAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAMUExURUdwTP///////////waf0AoAAAADdFJOUwDfIMe4PcYAAABHSURBVCjPY2AYhIApgGEKnMN5gakEzlFP4LwB58xtUE+AaykDcuFabgC5tNDCUMYg24Cdg6IMxQAUo1Espbom5KBCCcRBAwCLbCSRKY+ZQAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/下载.png
// module id = XhMq
// module chunks = 1